import type { Law } from "../types";

export const ironLawOfOligarchy: Law = {
  slug: "iron-law-of-oligarchy",
  title: "Iron Law of Oligarchy",
  definition: "Any large organization, however democratic in intent, tends to fall under the control of a small elite that consolidates power.",
  category: "theory",
  color: "#744210",
  labels: ["management", "economics", "epistemology"],
  copy: [
    "Robert Michels argued that the division of labor, delegation, and the need for coordination inevitably concentrate expertise and decision authority in a few hands, even in organizations founded on equality.",
    "The law is a caution about governance design: formal democratic structures do not prevent informal concentration of power, so attention must be paid to who holds information, who sets agendas, and who controls the feedback loops.",
  ],
  sources: ["https://en.wikipedia.org/wiki/Iron_law_of_oligarchy"],
  related: ["goodharts-law"],
};
